'use strict';
import angular from 'angular';
import linkedinAudienceHtmlUrl from './views/linkedinAudienceList.html';
import linkedinChildDataHtmlUrl from './views/linkedinRecursiveTemplate.html';
let app = angular.module('app.linkedinAudience.component', []);

app.component('linkedinAudienceTargeting', {
    bindings: {
        showActions: '=',
        selectedLinkedinAudience: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: linkedinAudienceHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService) {
        let self = this;

        self.intrestsList = [];
        self.jobExperienceList = [];
        self.jobTitleList = [];
        self.jobTitleSearch = '';
        self.companyIndustryList = [];
        self.companyIndustrySearch = '';
        self.degreeList = [];
        self.degreeSearch = '';
        self.fieldsOfStudyList = [];
        self.fieldsOfStudySearch = '';
        self.demographicsList = [];
        self.companyList = [];
        self.linkedinChildDataHtmlUrl = linkedinChildDataHtmlUrl;

        self.IsChildObjectVisible = function(parent, child) {
            let searchKey = $scope.search;
            let returnVal = true;
            if (undefined != searchKey && null != searchKey && searchKey.length > 0) {
                returnVal = ((child.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1) ||
                    (parent.name.toLowerCase().indexOf(searchKey.toLowerCase()) > -1));
            }
            return returnVal;
        }

        self.handleSelectSubChild = function(item, child, selectedLinkedinAudience,indx,type) {
            if (type == 'interests') {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.intrests.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.intrests, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.intrests.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.intrests.push(child);
                }
            } else if (type == "demographics") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.demographics.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.demographics, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.demographics.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.demographics.push(child);
                }
            } else if (type == "job experience") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.jobExperience.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.jobExperience, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.jobExperience.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.jobExperience.push(child);
                }
            } else if (type == "degree") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.degree.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.degree, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.degree.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.degree.push(child);
                }
            } else if (type == "company") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.company.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.company, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.company.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.company.push(child);
                }
            } else if (type == "job title") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.jobTitles.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.jobTitles, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.jobTitles.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.jobTitles.push(child);
                }
            } else if (type == "company industry") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.companyIndustries.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.companyIndustries, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.companyIndustries.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.companyIndustries.push(child);
                }
            } else if (type == "fields of study") {
                if (child.isChecked) {
                    child.status = '';
                    child.isChecked = false;
                    let selIndex = selectedLinkedinAudience.fieldsOfStudy.indexOf(child);
                    selIndex = _.findIndex(selectedLinkedinAudience.fieldsOfStudy, { id: child.id });
                    if (selIndex >= 0) {
                        selectedLinkedinAudience.fieldsOfStudy.splice(selIndex, 1);
                    }
                } else {
                    child.status = 'selected';
                    child.isChecked = true;
                    selectedLinkedinAudience.fieldsOfStudy.push(child);
                }
            }
        }

        self.addOverlap = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            if (data.excludeAdded) {
                self.hideExclude = true;
            }
            let excluded_index = _.findIndex(self.selectedLinkedinAudience, { excludeAdded: true });
            if (excluded_index >=0) {
                let exclude_data = self.selectedLinkedinAudience[excluded_index];
                self.selectedLinkedinAudience.splice(excluded_index,1);
            }
            self.selectedLinkedinAudience.push({intrests: [],
                jobExperience: [],
                jobTitles: [],
                demographics: [],
                degree: [],
                fieldsOfStudy: [],
                company: [],
                companyIndustries: [],
                overLapEnabled:true,
                overLapAdded: true ,
                excludeEnabled:self.hideExclude ? false :true,
                demographicsList:angular.copy(self.demographicsList),
                intrestsList:angular.copy(self.intrestsList),
                jobExperienceList:angular.copy(self.jobExperienceList),
                jobTitleList:angular.copy(self.jobTitleList),
                companyIndustryList:angular.copy(self.companyIndustryList),
                degreeList:angular.copy(self.degreeList),
                fieldsOfStudyList:angular.copy(self.fieldsOfStudyList),
                companyList:angular.copy(self.companyList)
            });
            if (exclude_data) {
                self.selectedLinkedinAudience.push(exclude_data);
            }
        }

        self.excludeAudience = function(data){
            data.overLapEnabled = false;
            data.excludeEnabled = false;
            self.selectedLinkedinAudience.push({intrests: [],
                jobExperience: [],
                jobTitles: [],
                degree: [],
                fieldsOfStudy: [],
                company: [],
                companyIndustries: [],
                demographics:[],
                overLapEnabled:true,
                overLapAdded:false,
                excludeAdded:true,
                excludeEnabled:false,
                demographicsList:angular.copy(self.demographicsList),
                intrestsList:angular.copy(self.intrestsList),
                jobExperienceList:angular.copy(self.jobExperienceList),
                jobTitleList:angular.copy(self.jobTitleList),
                companyIndustryList:angular.copy(self.companyIndustryList),
                degreeList:angular.copy(self.degreeList),
                fieldsOfStudyList:angular.copy(self.fieldsOfStudyList),
                companyList:angular.copy(self.companyList)
            });
        }

        self.removeAudienceSet = function(data,index){
            if (self.selectedLinkedinAudience.length == index + 1) {
                self.selectedLinkedinAudience.splice(index, 1);
                let selIndex = index - 1;
                if (selIndex >= 0) {
                    self.selectedLinkedinAudience[selIndex].excludeEnabled = true;
                    self.selectedLinkedinAudience[selIndex].overLapEnabled = true;
                    if (data.excludeAdded) {
                        self.hideExclude = false;
                    }
                }
            } else {
                self.selectedLinkedinAudience.splice(index, 1);
                if (data.excludeAdded) {
                    self.hideExclude = false;
                    let indexVal = self.selectedLinkedinAudience.length-1;
                    self.selectedLinkedinAudience[indexVal].excludeEnabled = true;
                }
            }
        }

        self.handleSelectDemographics = function(demographic,selectedLinkedinAudience) {
            if (!demographic.isChecked) {
                demographic.status = '';
                demographic.isChecked = false;
                let selIndex = selectedLinkedinAudience.demographics.indexOf(demographic);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.demographics.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.demographics && selectedLinkedinAudience.demographics.length > 0) {
                        if (_.find(selectedLinkedinAudience.demographicsList, { id: demographic.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.demographicsList, { id: demographic.id });
                            selectedLinkedinAudience.demographics.splice(index, 1);
                        }
                    }
                }
            } else {
                demographic.status = 'selected';
                demographic.isChecked = true;
                selectedLinkedinAudience.demographics.push(demographic);
            }
        }

        self.handleSelectIntrests = function(intrests, selectedLinkedinAudience) {
            if (!intrests.isChecked) {
                intrests.status = '';
                intrests.isChecked = false;
                let selIndex = selectedLinkedinAudience.intrests.indexOf(intrests);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.intrests.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.intrests && selectedLinkedinAudience.intrests.length > 0) {
                        if (_.find(selectedLinkedinAudience.intrestsList, { id: intrests.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.intrestsList, { id: intrests.id });
                            selectedLinkedinAudience.intrests.splice(index, 1);
                        }
                    }
                }
            } else {
                intrests.status = 'selected';
                intrests.isChecked = true;
                selectedLinkedinAudience.intrests.push(intrests);
            }
        }

        self.handleSelectCompanies = function(companies, selectedLinkedinAudience) {
            if (!companies.isChecked) {
                companies.status = '';
                companies.isChecked = false;
                let selIndex = selectedLinkedinAudience.company.indexOf(companies);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.company.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.company && selectedLinkedinAudience.company.length > 0) {
                        if (_.find(selectedLinkedinAudience.companyList, { id: companies.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.companyList, { id: companies.id });
                            selectedLinkedinAudience.company.splice(index, 1);
                        }
                    }
                }
            } else {
                companies.status = 'selected';
                companies.isChecked = true;
                selectedLinkedinAudience.company.push(companies);
            }
        }

        self.handleSelectDegree = function(degree, selectedLinkedinAudience) {
            if (!degree.isChecked) {
                degree.status = '';
                degree.isChecked = false;
                let selIndex = selectedLinkedinAudience.degree.indexOf(degree);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.degree.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.degree && selectedLinkedinAudience.degree.length > 0) {
                        if (_.find(selectedLinkedinAudience.degreeList, { id: degree.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.degreeList, { id: degree.id });
                            selectedLinkedinAudience.degree.splice(index, 1);
                        }
                    }
                }
            } else {
                degree.status = 'selected';
                degree.isChecked = true;
                selectedLinkedinAudience.degree.push(degree);
            }
        }

        self.handleSelectFieldsOfStudy = function(fieldsOfStudy, selectedLinkedinAudience) {
            if (!fieldsOfStudy.isChecked) {
                fieldsOfStudy.status = '';
                fieldsOfStudy.isChecked = false;
                let selIndex = selectedLinkedinAudience.fieldsOfStudy.indexOf(fieldsOfStudy);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.fieldsOfStudy.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.fieldsOfStudy && selectedLinkedinAudience.fieldsOfStudy.length > 0) {
                        if (_.find(selectedLinkedinAudience.fieldsOfStudyList, { id: fieldsOfStudy.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.fieldsOfStudyList, { id: fieldsOfStudy.id });
                            selectedLinkedinAudience.fieldsOfStudy.splice(index, 1);
                        }
                    }
                }
            } else {
                fieldsOfStudy.status = 'selected';
                fieldsOfStudy.isChecked = true;
                selectedLinkedinAudience.fieldsOfStudy.push(fieldsOfStudy);
            }
        }

        self.handleSelectJobExperience = function(jobExperience, selectedLinkedinAudience) {
            if (!jobExperience.isChecked) {
                jobExperience.status = '';
                jobExperience.isChecked = false;
                let selIndex = selectedLinkedinAudience.jobExperience.indexOf(jobExperience);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.jobExperience.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.jobExperience && selectedLinkedinAudience.jobExperience.length > 0) {
                        if (_.find(selectedLinkedinAudience.jobExperienceList, { id: jobExperience.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.jobExperienceList, { id: jobExperience.id });
                            selectedLinkedinAudience.jobExperience.splice(index, 1);
                        }
                    }
                }
            } else {
                jobExperience.status = 'selected';
                jobExperience.isChecked = true;
                selectedLinkedinAudience.jobExperience.push(jobExperience);
            }
        }

        self.handleSelectJobTitle = function(jobTitle, selectedLinkedinAudience) {
            if (!jobTitle.isChecked) {
                jobTitle.status = '';
                jobTitle.isChecked = false;
                let selIndex = selectedLinkedinAudience.jobTitles.indexOf(jobTitle);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.jobTitles.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.jobTitles && selectedLinkedinAudience.jobTitles.length > 0) {
                        if (_.find(selectedLinkedinAudience.jobTitleList, { id: jobTitle.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.jobTitleList, { id: jobTitle.id });
                            selectedLinkedinAudience.jobTitles.splice(index, 1);
                        }
                    }
                }
            } else {
                jobTitle.status = 'selected';
                jobTitle.isChecked = true;
                selectedLinkedinAudience.jobTitles.push(jobTitle);
            }
        }

        self.handleSelectCompanyIndustries = function(industries, selectedLinkedinAudience) {
            if (!industries.isChecked) {
                industries.status = '';
                industries.isChecked = false;
                let selIndex = selectedLinkedinAudience.companyIndustries.indexOf(industries);
                if (selIndex >= 0) {
                    selectedLinkedinAudience.companyIndustries.splice(selIndex, 1);
                } else {
                    if (selectedLinkedinAudience.companyIndustries && selectedLinkedinAudience.companyIndustries.length > 0) {
                        if (_.find(selectedLinkedinAudience.companyIndustryList, { id: industries.id })) {
                            let index = _.findIndex(selectedLinkedinAudience.companyIndustryList, { id: industries.id });
                            selectedLinkedinAudience.companyIndustries.splice(index, 1);
                        }
                    }
                }
            } else {
                industries.status = 'selected';
                industries.isChecked = true;
                selectedLinkedinAudience.companyIndustries.push(industries);
            }
        }

        self.clearSelectedData = function(item,totalList){
            _.each(totalList,function(e){
                if (e.id == item.id) {
                    e.status = '';
                    e.isChecked = false;
                }
                if (e.childData && e.childData.length > 0) {
                    self.clearSelectedData(item,e.childData)
                }
            })
        }

        self.removeDemographics = function(item, selectedDemographics, demographicsList) {
            let selIndex = selectedDemographics.indexOf(item);
            if (selIndex >= 0) {
                selectedDemographics.splice(selIndex, 1);
            }
            self.clearSelectedData(item,demographicsList);
        }

        self.removeIntrests = function(item, selectedIntrests, intrestsList) {
            let selIndex = selectedIntrests.indexOf(item);
            if (selIndex >= 0) {
                selectedIntrests.splice(selIndex, 1);
                self.clearSelectedData(item,intrestsList);
            }
        }

        self.removeJobExperiences = function(item, selectedJobExperiences, jobExperiencesList) {
            let selIndex = selectedJobExperiences.indexOf(item);
            if (selIndex >= 0) {
                selectedJobExperiences.splice(selIndex, 1);
                self.clearSelectedData(item,jobExperiencesList);
            }
        }

        self.removeJobTitles = function(item, selectedJobTitles, jobTitleList) {
            let selIndex = selectedJobTitles.indexOf(item);
            if (selIndex >= 0) {
                selectedJobTitles.splice(selIndex, 1);
                self.clearSelectedData(item,jobTitleList);
            }
        }

        self.removeDegree = function(item, selectedDegrees, degreeList) {
            let selIndex = selectedDegrees.indexOf(item);
            if (selIndex >= 0) {
                selectedDegrees.splice(selIndex, 1);
                self.clearSelectedData(item,degreeList);
            }
        }

        self.removeFieldsOfStudy = function(item, selectedFieldsOfStudy, fieldsOfStudyList) {
            let selIndex = selectedFieldsOfStudy.indexOf(item);
            if (selIndex >= 0) {
                selectedFieldsOfStudy.splice(selIndex, 1);
                self.clearSelectedData(item,fieldsOfStudyList);
            }
        }

        self.removeCompany = function(item, selectedCompanies, companiesList) {
            let selIndex = selectedCompanies.indexOf(item);
            if (selIndex >= 0) {
                selectedCompanies.splice(selIndex, 1);
                self.clearSelectedData(item,companiesList);
            }
        }

        self.removeCompanyIndustry = function(item, selectedIndustries, industriesList) {
            let selIndex = selectedIndustries.indexOf(item);
            if (selIndex >= 0) {
                selectedIndustries.splice(selIndex, 1);
                self.clearSelectedData(item,industriesList);
            }
        }

        self.getDemographics = function() {
            ProductService.getDemographicsContentForLinkedin({clientId:self.clientId,clusterId:self.clusterId}).then(function(success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function(content) {
                        let demographics = {};
                        demographics.id = content.id;
                        demographics.name = content.name.charAt(0).toUpperCase()+content.name.replace("_"," ").slice(1);
                        demographics.status = "";
                        demographics.isChecked = false;
                        demographics.isExpand = false;
                        demographics.parentName = content.parentName;
                        demographics.childData = content.childData;
                        demographics.type = content.type;
                        self.demographicsList.push(demographics);
                    });
                    _.each(self.selectedLinkedinAudience,function(item){
                        item.demographicsList = angular.copy(self.demographicsList);
                    })
                    processDemographicsData();
                }
            }, function(error) { });
        }

        self.getIntrests = function() {
            ProductService.getInterestsContentForLinkedin({ clientId:self.clientId,clusterId:self.clusterId}).then(function(success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function(content) {
                        let intrests = {};
                        intrests.id = content.id;
                        intrests.name = content.name;
                        intrests.status = "";
                        intrests.isChecked = false;
                        intrests.parentName = content.parentName;
                        intrests.childData = content.childData;
                        intrests.type = content.type;
                        intrests.adTargetingFacet = content.adTargetingFacet;
                        self.intrestsList.push(intrests);
                    });
                    _.each(self.selectedLinkedinAudience,function(item){
                        item.intrestsList = angular.copy(self.intrestsList);
                    })
                    processIntrestsData();
                }
            }, function(error) { });
        }

        self.searchDegree = function(event) {
            if (event.keyCode == 13) {
                ProductService.getDegreeContentForLinkedin({ clientId: self.clientId, clusterId: self.clusterId, keyword: self.degreeSearch }).then(function(success) {
                    if (success && success.data && success.data.length > 0) {
                        self.errorFetchingDegree = false;
                        self.degreeList = []; // Clear existing list
                        _.each(success.data, function(content) {
                            let degree = {
                                id: content.id,
                                name: content.name,
                                status: "",
                                isChecked: false,
                                parentName: content.parentName,
                                childData: content.childData,
                                type: content.type,
                                adTargetingFacet: content.adTargetingFacet
                            };
                            self.degreeList.push(degree);
                        });
                        _.each(self.selectedLinkedinAudience, function(item) {
                            item.degreeList = angular.copy(self.degreeList);
                        });
                        processDegreeData();
                    } else {
                        self.errorFetchingDegree = true;
                        self.degreeList = []; // Clear existing list
                    }
                }, function(error) {});
            }
        }

        self.searchFieldsOfStudy = function(event) {
            if (event.keyCode == 13) {
                ProductService.getFieldsOfStudyContentForLinkedin({ clientId: self.clientId, clusterId: self.clusterId, keyword: self.fieldsOfStudySearch }).then(function(success) {
                    if (success && success.data && success.data.length > 0) {
                        self.errorFetchingFieldsOfStudy = false;
                        self.fieldsOfStudyList = []; // Clear existing list
                        _.each(success.data, function(content) {
                            let fieldsOfStudy = {
                                id: content.id,
                                name: content.name,
                                status: "",
                                isChecked: false,
                                parentName: content.parentName,
                                childData: content.childData,
                                type: content.type,
                                adTargetingFacet: content.adTargetingFacet
                            };
                            self.fieldsOfStudyList.push(fieldsOfStudy);
                        });
                        _.each(self.selectedLinkedinAudience, function(item) {
                            item.fieldsOfStudyList = angular.copy(self.fieldsOfStudyList);
                        });
                        processFieldsOfStudyData();
                    } else {
                        self.errorFetchingFieldsOfStudy = true;
                        self.fieldsOfStudyList = []; // Clear existing list
                    }
                }, function(error) {});
            }
        }

        self.getCompany = function() {
            ProductService.getCompanyContentForLinkedin({ clientId:self.clientId,clusterId:self.clusterId}).then(function(success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function(content) {
                        let company = {};
                        company.id = content.id;
                        company.name = content.name;
                        company.status = "";
                        company.isChecked = false;
                        company.parentName = content.parentName;
                        company.childData = content.childData;
                        company.type = content.type;
                        self.companyList.push(company);
                    });
                    _.each(self.selectedLinkedinAudience,function(item){
                        item.companyList = angular.copy(self.companyList);
                    })
                    processCompanyData();
                }
            }, function(error) { });
        }

        self.getJobExperience = function() {
            ProductService.getJobExperienceContentForLinkedin({ clientId:self.clientId,clusterId:self.clusterId}).then(function(success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function(content) {
                        let jobExperience = {};
                        jobExperience.id = content.id;
                        jobExperience.name = content.name;
                        jobExperience.status = "";
                        jobExperience.isChecked = false;
                        jobExperience.parentName = content.parentName;
                        jobExperience.childData = content.childData;
                        jobExperience.type = content.type;
                        self.jobExperienceList.push(jobExperience);
                    });
                    _.each(self.selectedLinkedinAudience,function(item){
                        item.jobExperienceList = angular.copy(self.jobExperienceList);
                    })
                    processJobExperienceData();
                }
            }, function(error) { });
        }

        self.searchJobTitle = function(event) {
            if (event.keyCode == 13) {
                ProductService.getJobTitleContentForLinkedin({ clientId: self.clientId, clusterId: self.clusterId, keyword: self.jobTitleSearch }).then(function(success) {
                    if (success && success.data && success.data.length > 0) {
                        self.errorFetchingJobTitle = false;
                        self.jobTitleList = []; // Clear existing list
                        _.each(success.data, function(content) {
                            let jobTitle = {
                                id: content.id,
                                name: content.name,
                                status: "",
                                isChecked: false,
                                parentName: content.parentName,
                                childData: content.childData,
                                type: content.type,
                                adTargetingFacet: content.adTargetingFacet
                            };
                            self.jobTitleList.push(jobTitle);
                        });
                        _.each(self.selectedLinkedinAudience, function(item) {
                            item.jobTitleList = angular.copy(self.jobTitleList);
                        });
                        processJobTitleData();
                    } else {
                        self.errorFetchingJobTitle = true;
                        self.jobTitleList = []; // Clear existing list
                    }
                }, function(error) {});
            }
        }

        self.searchCompanyIndustry = function(event) {
            if (event.keyCode == 13) {
                ProductService.getCompanyIndustryContentForLinkedin({ clientId: self.clientId, clusterId: self.clusterId, keyword: self.companyIndustrySearch }).then(function(success) {
                    if (success && success.data && success.data.length > 0) {
                        self.errorFetchingCompanyIndustry = false;
                        self.companyIndustryList = []; // Clear existing list
                        _.each(success.data, function(content) {
                            let companyIndustry = {
                                id: content.id,
                                name: content.name,
                                status: "",
                                isChecked: false,
                                parentName: content.parentName,
                                childData: content.childData,
                                type: content.type,
                                adTargetingFacet: content.adTargetingFacet
                            };
                            self.companyIndustryList.push(companyIndustry);
                        });
                        _.each(self.selectedLinkedinAudience, function(item) {
                            item.companyIndustryList = angular.copy(self.companyIndustryList);
                        });
                        processCompanyIndustryData();
                    } else {
                        self.errorFetchingCompanyIndustry = true;
                        self.companyIndustryList = []; // Clear existing list
                    }
                }, function(error) {});
            }
        }

        let processIntrestsData = function() {
            _.each(self.selectedLinkedinAudience, function(data) {
                _.each(data.intrests, function(item) {
                    _.each(data.intrestsList, function(e) {
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubIntrests(e.childData,data.intrests);
                        }
                    })
                })
            })
        }

        let processSubIntrests = function(childData,selectedIntrests){
            _.each(selectedIntrests,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubIntrests(e.childData,selectedIntrests);
                    }
                })
            })
        }

        let processDemographicsData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.demographics,function(item){
                    _.each(data.demographicsList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubDemographics(e.childData,data.demographics);
                        }
                    })
                })
            })
        }

        let processSubDemographics = function(childData,selectedDemographics){
            _.each(selectedDemographics,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubDemographics(e.childData,selectedDemographics);
                    }
                })
            })
        }

        let processCompanyData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.company,function(item){
                    _.each(data.companyList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubCompanyData(e.childData,data.company);
                        }
                    })
                })
            })
        }

        let processSubCompanyData = function(childData,selectedCompanies){
            _.each(selectedCompanies,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubCompanyData(e.childData,selectedCompanies);
                    }
                })
            })
        }

        let processCompanyIndustryData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.companyIndustries,function(item){
                    _.each(data.companyIndustryList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubCompanyIndustryData(e.childData,data.companyIndustries);
                        }
                    })
                })
            })
        }

        let processSubCompanyIndustryData = function(childData,selectedIndustries){
            _.each(selectedIndustries,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubCompanyIndustryData(e.childData,selectedIndustries);
                    }
                })
            })
        }

        let processDegreeData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.degree,function(item){
                    _.each(data.degreeList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubDegreeData(e.childData,data.degree);
                        }
                    })
                })
            })
        }

        let processSubDegreeData = function(childData,selectedDegree){
            _.each(selectedDegree,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubDegreeData(e.childData,selectedDegree);
                    }
                })
            })
        }

        let processFieldsOfStudyData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.fieldsOfStudy,function(item){
                    _.each(data.fieldsOfStudyList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubFieldsOfStudyData(e.childData,data.fieldsOfStudy);
                        }
                    })
                })
            })
        }

        let processSubFieldsOfStudyData = function(childData,selectedFieldsOfStudy){
            _.each(selectedFieldsOfStudy,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubFieldsOfStudyData(e.childData,selectedFieldsOfStudy);
                    }
                })
            })
        }

        let processJobTitleData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.jobTitles,function(item){
                    _.each(data.jobTitleList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubJobTitleData(e.childData,data.jobTitles);
                        }
                    })
                })
            })
        }

        let processSubJobTitleData = function(childData,selectedJobTitle){
            _.each(selectedJobTitle,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubJobTitleData(e.childData,selectedJobTitle);
                    }
                })
            })
        }

        let processSubJobExperienceData = function(childData,selectedJobExperience){
            _.each(selectedJobExperience,function(item){
                _.each(childData,function(e){
                    if (e.id == item.id) {
                        e.status = 'selected';
                        e.isChecked = true;
                    }
                    if (e.childData && e.childData.length > 0) {
                        processSubJobExperienceData(e.childData,selectedJobExperience);
                    }
                })
            })
        }

        let processJobExperienceData = function(){
            _.each(self.selectedLinkedinAudience,function(data){
                _.each(data.jobExperience,function(item){
                    _.each(data.jobExperienceList,function(e){
                        if (e.id == item.id) {
                            e.status = 'selected';
                            e.isChecked = true;
                        }
                        if (e.childData && e.childData.length > 0) {
                            processSubJobExperienceData(e.childData,data.jobExperience);
                        }
                    })
                })
            })
        }

        self.setExclude = function(){
            _.each(self.selectedLinkedinAudience,function(item){
                if (item.excludeAdded) {
                    self.hideExclude = true;
                }
            })
        }

        self.initComponent = function() {
            if (self.selectedLinkedinAudience && !_.isEmpty(self.selectedLinkedinAudience)) {
                self.selectedLinkedinAudience = JSON.parse(self.selectedLinkedinAudience);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getIntrests();
                    self.getCompany();
                    self.getJobExperience();
                    self.getDemographics();
                    self.setExclude();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedLinkedinAudience = [{
                    intrests: [],
                    demographics:[],
                    jobExperience: [],
                    jobTitles: [],
                    degree: [],
                    fieldsOfStudy: [],
                    company: [],
                    companyIndustries: [],
                    overLapEnabled:true,
                    excludeEnabled:true
                }];
                self.enableViewMode = false;
                self.getIntrests();
                self.getCompany();
                self.getJobExperience();
                self.getDemographics();
            }
        };

        self.initComponent();
    }
});